(function () {
    'use strict';

    angular
        .module('tfc.retailer.Filter')
        .directive('tfcFilter', tfcFilter);

    function tfcFilter() {
        return {
            restrict: 'E',
            templateUrl: 'Util/Filters/Filter.tmpl.html',
            controller: 'FilterCtrl as vm',
            bindToController: true,
            scope: {
                filter: '=',
                reload: '&',
                selectedBrand: '='
            }
        };
    }

}());